import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';

const json = {

  1: { // Exercise num
    unit: 'Unit 2',
    id: 'WB3-U2-P18-E1',
    audio: '',
    video: '',
    component: UI,
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page18/E1/1.jpg' },
      ],
    ]
  },
  2: { // Exercise num
    unit: 'Unit 2',
    id: 'WB3-U2-P18-E2',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page18/E2/Key/answerKey.png',
    // titleQuestion: [{ num: '2', title: 'Read again. Circle four things that students can do.', color: "#5B5A5D" }],
    question: {
      Write: {
        inputStyle: { width: 420 },
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: { border: 'solid 3px', borderRadius: '50%', borderColor: 'transparent' },
        selectWordStyle: { borderColor: '#4285F4' },
        // limitSelect: 1,
        listWords: [
          "My name's Anh. This is my classroom.",
          "The tables are long. There's a big board and there are",
          "two computers. There are big posters on the wall. There",
          "are pictures, too. Can you see my picture? It's a picture",
          "of my family. My teacher is Miss Tam. I like her.",
        ],
        answers: ['1-2', '1-14', '2-2', '2-10', '3-2'],
        initialValue: [],
      },
      Layout: `
      <div style="position: relative;">
        <img src="img/FriendsPlus/Page18/E2/1.jpg" />
        <div style="position: absolute;top:71px ;left:238px">
          <div> <input id='0' type='Circle' /></div>
          <div> <input id='1' type='Circle' /></div>
          <div> <input id='2' type='Circle' /></div>
          <div> <input id='3' type='Circle' /></div>
          <div> <input id='4' type='Circle' /></div>
        </div>
      </div>
      `,
    },
  },
  3: { // Exercise num
    unit: 'Unit 2',
    id: 'WB3-U2-P18-E3',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 3,
    exerciseKey: 'img/FriendsPlus/Page18/E3/Key/answerKey.png',
    titleImage: '',
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1a
        { url: 'img/FriendsPlus/Page18/E3/1a.jpg' },
      ],
      [
        // Column1b
        { url: 'img/FriendsPlus/Page18/E3/1b.jpg' },
      ],
      [
        // Column1c
        { url: 'img/FriendsPlus/Page18/E3/1c.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page18/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page18/E3/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page18/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page18/E3/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page18/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page18/E3/7.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page18/E3/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page18/E3/9.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page18/E3/10.jpg' },
        { url: 'img/FriendsPlus/Page18/E3/11.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page18/E3/12.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page18/E3/13.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page18/E3/14.jpg' },
        { url: 'img/FriendsPlus/Page18/E3/15.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page18/E3/16.jpg' },
        { url: 'img/FriendsPlus/Page18/E3/17.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page18/E3/18.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page18/E3/19.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page18/E3/20.jpg' },
        { url: 'img/FriendsPlus/Page18/E3/21.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page18/E3/22.jpg' },
        { url: 'img/FriendsPlus/Page18/E3/23.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page18/E3/24.jpg' },
      ],
      [
        // Column11
        { url: 'img/FriendsPlus/Page18/E3/25.jpg' },
      ],
      [
        // Column12
        { url: 'img/FriendsPlus/Page18/E3/26.jpg' },
        { url: 'img/FriendsPlus/Page18/E3/27.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page18/E3/28.jpg' },
        { url: 'img/FriendsPlus/Page18/E3/29.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page18/E3/30.jpg' },
      ],
      [
        // Column12
        { url: 'img/FriendsPlus/Page18/E3/30.jpg' },
        { url: 'img/FriendsPlus/Page18/E3/30.jpg' },
        { url: 'img/FriendsPlus/Page18/E3/30.jpg' },
        { url: 'img/FriendsPlus/Page18/E3/30.jpg' },
      ],


    ],
  },

}

export default json;